import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import { Typography } from "antd";

import styles from "components/PlatformLayout/components/PlatformPageHeader/PlatformPageHeader.module.less";

const { Title } = Typography;

const AdminBreadCrumbs = () => {
  const [tabTitle, setTabTitle] = useState(null);
  const history = useHistory();
  const params = useParams();

  const handleBaseNavigate = () => {
    history.push("/admin-reports");
    setTabTitle(null);
  };

  useEffect(() => {
    if (params.tab) setTabTitle(params.tab.replace(/-/g, " "));
  }, [params]);

  const baseStyle = {
    cursor: "pointer",
    textTransform: "capitalize",
    fontWeight: 600,
  };

  const secondaryStyle = {
    textTransform: "capitalize",
  };

  return (
    <>
      <Title className={styles.title} style={baseStyle} onClick={handleBaseNavigate}>
        Admin Reports
      </Title>
      {tabTitle && (
        <>
          <span className={styles.titleSeparator}>/</span>
          <Title className={styles.titleSecondary} style={secondaryStyle}>
            {tabTitle}
          </Title>
        </>
      )}
    </>
  );
};

export default AdminBreadCrumbs;
